import type { ConstructorType } from '@/src/shared/domain/interfaces/constructor.types';


export class SendContactFormInputModel {
  name: string;
  surnames: string;
  email: string;
  company: string;
  phone: string;
  rate: string;
  numberOfPeople: number;
  city: string;

  constructor(params: ConstructorType<SendContactFormInputModel>) {
    this.name = params.name;
    this.surnames = params.surnames;
    this.email = params.email;
    this.company = params.company;
    this.phone = params.phone;
    this.rate = params.rate;
    this.numberOfPeople = params.numberOfPeople;
    this.city = params.city;
  }
}
